<template>
	<div
		class="sidearm-ad ad"
		v-if="
			(campaigns && campaigns.length) ||
				(location && location.type === 'dfp')
		"
	>
		<component
			v-if="location && location.type"
			:is="location.type"
			:name="name"
			:location="location"
			:campaigns="campaigns"
		/>
	</div>
</template>

<script>
import Client from '@/client';
import ElementAdSingle from '@/components/ads/ElementAdSingle.vue';
import ElementAdDfp from '@/components/ads/ElementAdDfp.vue';
import ElementAdIcons from '@/components/ads/ElementAdIcons.vue';
import ElementAdHtml from '@/components/ads/ElementAdHtml.vue';
import { should_use_v2_api } from '@/helpers';

export default {
	props: {
		name: {
			type: String,
			required: true,
			default: '',
		},
	},

	components: {
		single: ElementAdSingle,
		dfp: ElementAdDfp,
		icons: ElementAdIcons,
		htmlAd: ElementAdHtml,
	},

	data: () => ({
		location: null,
		sport_id: 0,
		campaigns: [],
	}),

	methods: {
		get_campaigns() {
			if (should_use_v2_api()) {
				this.fetch_campaign_from_v2_api();
			} else {
				this.fetch_campaign_from_legacy_api();
			}
		},
		fetch_campaign_from_legacy_api() {
			let request_options = {
				type: 'ads',
				sport_id: this.sport_id,
				name: this.name,
			};
			Client.get('/services/adaptive_components.ashx', {
				params: request_options,
			}).then(response => {
				let ad = response.data;
				let _location = ad.location;
				_location.type =
					_location.type === 'html' ? 'html-ad' : _location.type;
				this.location = _location;
				this.campaigns = ad.campaigns;
			});
		},
		fetch_campaign_from_v2_api() {
			Client.get(`/api/v2/Promotions/${this.name}/${this.sport_id}`).then(
				response => {
					var data = this.map_v2_response(response.data);
					let _location = data.location;
					_location.type =
						_location.type === 'html' ? 'html-ad' : _location.type;
					this.location = _location;
					this.campaigns = data.campaigns;
				},
			);
		},
		map_v2_response(data) {
			// Maps v2 response into v1 response object
			return data != '' && data != null
				? {
						location: {
							id: data.location.id,
							title: data.location.title,
							type: data.location.locationType,
							effect: data.location.effect,
							sidearm_dfp: data.location.sidearmDfp,
							common_page: data.location.commonPage,
							excluded_sport_ids: data.location.excludedSportIds,
							name: data.location.name,
							slick: data.location.slick,
							dfp: data.location.dfp,
							fixed_image_sizes: data.location.fixedImageSizes,
							autoplay_speed: data.location.autoplaySpeed,
							accessibility_icons:
								data.location.accessibilityIcons,
							slick_options: data.location.slickOptions.map(
								x => ({
									breakpoint: x.breakpoint,
									arrows: x.arrows,
									dots: x.dots,
									slides_to_show: x.slidesToShow,
									slides_to_scroll: x.slidesToScroll,
									extraOptions: x.extraOptions,
								}),
							),
							dfp_sizes: data.location.dfpSizes.map(x => ({
								id: x.dfpId,
								enabled: x.enabled,
								breakpoint: x.breakpoint,
								width: x.width,
								height: x.height,
								size_list: x.sizeList,
								unit_name: x.unitName,
							})),
						},
						campaigns: data.campaigns.map(x => ({
							id: x.id,
							title: x.title,
							start_date: x.startDate,
							end_date: x.endDate,
							open_in_new_window: x.openInNewWindow,
							icon: x.iconClass,
							html: x.html,
							link: x.link,
							css_class: x.cssClass,
							hover_text: x.hoverText,
							picture: x.picture.images.map(x => ({
								breakpoint: x.breakpoint,
								alt: x.imageAltText,
								image: x.image,
								width: x.width,
								height: x.height,
							})),
						})),
				  }
				: {
						// v1 returns this object if no ad exists whereas v2 returns 204 No Content response
						location: {
							id: 0,
							title: null,
							type: null,
							effect: null,
							fixed_image_sizes: false,
							excluded_sport_ids: null,
							slick: false,
							dfp: false,
							sidearm_dfp: false,
							common_page: false,
							html_template: null,
							name: null,
							autoplay_speed: 0,
							accessibility_icons: false,
							sizes: null,
							slick_options: null,
							dfp_sizes: null,
						},
						campaigns: [],
						content_id: null,
						content_title: null,
						content_date: null,
						content_url: null,
						content_image_url: null,
				  };
		},
	},
	watch: {
		'$root.signing_day.sport': function() {
			if (this.$root.signing_day.sport) {
				this.sport_id = this.$root.signing_day.sport.id;
				this.get_campaigns();
			}
		},
	},
	created() {
		this.get_campaigns();
	},
};
</script>
